module.exports = __webpack_public_path__ + "img/SiteBanner.83610980.png";